import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axios from "axios";
import { IBooking, ReactQueryKey } from "../../types";

export const getBookingById = async (id: string): Promise<IBooking> => {
    const response = await axios.get(`/booking/findById/${id}`);
    return response.data;
};

export const useBookingByIdQuery = (id?: string, options?: UseQueryOptions<IBooking | null>) => {
    return useQuery<IBooking | null>(
        [ReactQueryKey.BookingById, id],
        () => {
            if (!id) {
                return null;
            }
            return getBookingById(id);
        },
        options
    )
};

export const useBookingByIdQueryObserver = (id?: string) => {
    return useQuery<IBooking | null>({
        queryKey: [ReactQueryKey.BookingById, id],
        enabled: false
    });
};